<template>
  <div class="indicator-wrapper">
    <div class="indicator-content" :class="{blurred: isFetching}">
      <slot></slot>
    </div>
    <transition name="fade">
      <Loading v-if="isFetching"></Loading>
    </transition>
    <transition name="fade">
      <div class="no-data" v-if="!isFetching && !hasData">
        <div class="text">{{noDataText}}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loading from '@/components/IndicatorCards/parts/Loader'
export default {
  props:{
    status: Object,
    isMain: Boolean,
    currentFilters: Object
  },
  computed: {
    isFetching(){
      return this.status.status === 'fetching'
    },
    hasData () {
      return this.status.status === 'ready'
    },
    noDataText () {
      // console.log(this.currentFilters)
      if(this.isMain && !this.currentFilters.sector_recovery) {
        return this.t('no_data_for_node').replace('%ORIGIN%',this.$store.state.nodeInfo.value)
      } else {
        return this.t('no_data_for_these_filters')
      }
    }
  },
  components: {
    Loading
  }
}
</script>

<style scoped lang="stylus">
.indicator-wrapper
  flex 1 0 0
  .indicator-content
    flex: 1 1 auto;
    display: flex;
    .mobile &
      flex-direction column
  //   width: 100%;
  //   &.blurred
  //     filter: blur(4px)
  .fade-enter-active, .fade-leave-active
    transition opacity .3s
    // overflow hidden
  .fade-enter, .fade-leave-to
    opacity 0


  .no-data
    position absolute
    width 100%
    height vh(40px)
    background #fdd
    color #000
    top 0
    left 0
    font-size 25px
    z-index 1
    box-shadow 0 0 5px rgba(0,0,0,0.5)
    padding vw(5px)
    display: flex;
    align-items: center;
    .text
      m-font-size(14,20)
      font-family 'Lato'
      margin-left vw(10px)
</style>